
import CryptoJS from 'crypto-js';
import env from '../utils/env';
import { storageGetItem } from '../utils/local-storage';
import { AFFILIATE_ID } from '../utils/storage-keys';

const getAffiliateId = () => {
  const config = env();
  const encryptedUserIdFromStorage = storageGetItem(AFFILIATE_ID);
  if (!encryptedUserIdFromStorage) {
    return;
  }
  const affiliateId = CryptoJS.AES.decrypt(encryptedUserIdFromStorage, config.affiliateToken).toString(CryptoJS.enc.Utf8);
  return affiliateId;
}

export default getAffiliateId;
